var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"\n    menu-close\n  "),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"NAV_:_Opened","data-name":"NAV : Opened"},[React.createElement("line",{"x1":"1.05","x2":"23.55","y1":"1.07","y2":"22.98","fill":"none","stroke":"none","strokeMiterlimit":"10","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"23.55","x2":"1.05","y1":"1.07","y2":"22.98","fill":"none","stroke":"none","strokeMiterlimit":"10","strokeWidth":"3","key":1})]))]);
}

MenuClose.defaultProps = {"viewBox":"0 0 24.59 24.06"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
